import Spinner from "react-bootstrap/Spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVideo } from "@fortawesome/free-solid-svg-icons";

export const AppSpinner = () => (
    <div className="app-spinner">
        <div className="app-spinner__wrapper">
            <div className="app-spinner__icon">
                <FontAwesomeIcon icon={faVideo} size="2x" />
            </div>
            <Spinner animation="border" variant="primary" className="app-spinner__spinner" />
        </div>
        <span className="visually-hidden">Loading...</span>
    </div>
);